export const TITLES = [
  "Software Developer",
  "Data Analyst",
  "Full Stack Developer",
  "Problem Solver",
  "Really Fast Typer"
]
export const INTRO_TEXT = "I type words really fast on a computer to make and build things.";

export const LANGUAGES = [
  { icon: "/logos/c_logo.svg", name: "C" },
  { icon: "/logos/elixir.svg", name: "Elixir" },
  { icon: "/logos/go.svg", name: "Golang" },
  { icon: "/logos/java.svg", name: "Java" },
  { icon: "/logos/javascript.svg", name: "JavaScript" },
  { icon: "/logos/kotlin.svg", name: "Kotlin" },
  { icon: "/logos/ocaml.svg", name: "OCaml" },
  { icon: "/logos/python.svg", name: "Python" },
  { icon: "/logos/r_logo.svg", name: "R" },
  { icon: "/logos/rust.svg", name: "Rust" },
];

export const FRAMEWORKS = [
  { icon: "/logos/astro.svg", name: "Astro"},
  { icon: "/logos/bootstrap.svg", name: "Bootstrap" },
  { icon: "/logos/ejs.svg", name: "EJS" },
  { icon: "/logos/express.svg", name: "Express.js" },
  { icon: "/logos/jquery.svg", name: "jQuery" },
  { icon: "/logos/nextjs.svg", name: "Next.js" },
  { icon: "/logos/react.svg", name: "React" },
];

export const TOOLS = [
  { icon: "/logos/git.svg", name: "Git" },
  { icon: "/logos/linux.svg", name: "Linux (I love Mint)" },
  { icon: "/logos/mssql.svg", name: "Microsoft SQL Server" },
  { icon: "/logos/mysql.svg", name: "MySQL" },
  { icon: "/logos/mongodb.svg", name: "MongoDB" },
  { icon: "/logos/nodejs.svg", name: "Node.js" },
  { icon: "/logos/prisma.svg", name: "PrismaDB" },
  { icon: "/logos/ssrs.svg", name: "SQL Server Reporting Services" },
];

export const PROJECTS = [
  {
    title: "IOU",
    short: "A real-time bill splitting web app built for groups who want to settle up without the back-and-forth.",
    long: "Now typically in group settings it is really easy to split bills evenly, just pull out the calculator and divide by n people. However, I started having dinners where someone orders a particular item for themselves, and then the group gets headaches trying to subtract that item's cost from everyone else's subtotal. This app was built to solve those issues and prevent me from taking a Tylenol to cure my headaches from it.",
    image: "thumbnails/iou.png",
    stack: ["TypeScript", "React", "Tailwind CSS", "Supabase", "PostgreSQL", "Vite", "Vercel"],
    live: "https://iou.arekk.org/",
    github:"https://github.com/eric-deau/bill-splitter"
  },
  {
    title: "GitGud",
    short: "A mini web-game where users score by shooting targets.",
    long: "As a long time FPS player, I was always constantly training my aim. However, that was not always doable when away from home or at a computer without a game installed. This project was for cases where I was away from home and needed to keep up my muscle memory and ensure my aim was precise every time.",
    image: "thumbnails/gitgud.png",
    stack: ["JavaScript", "React", "Tailwind CSS", "Python", "Flask", "Docker", "MySQL"],
    live: "https://gitgud.arekk.org/",
    github:"https://github.com/eric-deau/aim_trainer"
  },
  {
    title: "Budget Galaga",
    short: "Desktop-focused interactive game where users shoot asteroids and score as high as possible.",
    long: "My very first project and introduction to programming. Created using vanilla JavaScript, CSS, and Canvas, I used to visit CHQ and eSpot frequently during my youth, and I thought this idea was a great way to begin my journey into coding.",
    image: "/thumbnails/galaga.png",
    stack: ["JavaScript", "CSS", "Canvas", "MySQL"],
    live: "https://budgetgalaga.netlify.app/",
    github: "https://github.com/eric-deau/TriangleDestroyingRocks"
  },
  {
    title: "Vancouver Housing Market",
    short: "Multiplayer-based board game where users compete against each other for ownership of properties.",
    long: "A 24-man class project and the final send-off to my time in the BCIT CST program. Created using Elixir and Phoenix Liveview, this project originally started through a collection of ideas by all classmates. Ultimately, we wanted something board-game themed, and came together to assemble a Vancouver-inspired multiplayer game.",
    image: "/thumbnails/vhm.png",
    stack: ["Elixir", "Phoenix Liveview", "JavaScript"],
    live: "https://monopoly.arekk.org/",
    github: "https://github.com/eric-deau/VancouverHousingMarket"
  },
  {
    title: "TextStory",
    short: "CLI interactive RPG where you travel and fight monsters to try and escape a dungeon!",
    long: "A python project that I themed after a childhood video game I used to play called Maplestory. At the time of development, I was heavily into MMORPGs and RPGs such as Lost Ark and Genshin Impact, so my environment at the time heavily influenced this project.",
    image: "thumbnails/textstory.png",
    stack: ["Python"],
    live: "",
    github:"https://github.com/eric-deau/TextStory"
  },
];

export const TIMELINE = [
  {
    type: 'work',
    title: 'Data Analyst Co-op',
    organization: 'Fraser Health Authority',
    date: '2024 – 2025',
    description: 'Assisted client partners with reporting and data-driven insights. Designed, developed, and optimized data reports through MSSQL, Python, PowerBI, Microsoft Excel, and Microsoft Access. Automated SSRS administrative tasks through PowerShell scripting. Supported rollout of new scheduling technology and nurse incentive programs, collaborating with stakeholders to gather requirements and deliver clear, reliable reports.',
  },
  {
    type: 'education',
    title: 'Computer Systems Programming Paradigms Option Co-operative Education Program',
    organization: 'British Columbia Institute of Technology',
    date: '2023 – 2025',
    description: '89% GPA.',
  },
  {
    type: 'work',
    title: 'Sales Representative',
    organization: 'Canada Computers and Electronics',
    date: '2018 – 2022',
    description: 'Consulted with clients to identify needs for appropriate hardware solutions, and delivering after-sales services. Assembled systems, ensured optimal performance through configuration and vigorous testing. Diagnosed and resolved hardware and software issues guiding customers through verbal and written communication. Built strong customer relations by providing reliable product knowledge.',
  },
];


export const EMAIL = "ericdeau.work@gmail.com"
export const PHONE = "(+1) 778-228-0365"
export const PHONE_REDIRECT = "+17782280365"
export const FULL_NAME = "Eric Deau"
export const GITHUB_LINK = "https://github.com/eric-deau"
export const LINKEDIN_LINK = "https://www.linkedin.com/in/eric-deau/"
export const CONTACT_TITLE = "Software Developer · Data Analyst"

export const LINE1 = "a website about eric deau";
export const LINE2 = "because a cover letter wasnt enough";
export const LINE3 = "pls enjoy";

export const WORD_INTERVAL = 750;
export const HOLD_DURATION = 3000;
export const FADE_DURATION = 1000;